import { TS_HISTORY, TS_LEADERBOARD, TS_REGISTER, TS_EVENT } from '../actions/top_spender/type';

const initState = {
    leaderboards: [],
    registerResult: null,
    registerError: null,
    history: {
        records: [],
        count: 0,
        totalApprovedAmount: 0,
        totalRegisteredAmount: 0,
        totalApprovedRights: 0
    },
    eventResult: null,
    eventData: null
}
export default function (state = initState, action) {
    switch (action.type) {
        case TS_REGISTER:
            return { ...state, registerResult: action.payload, registerError: action.message }
        case TS_LEADERBOARD:
            return { ...state, leaderboards: action.payload }
        case TS_HISTORY:
            return {
                ...state,
                history: {
                    records: action.payload.data,
                    count: action.payload.count,
                    totalApprovedAmount: action.payload.totalApprovedAmount || 0,
                    totalRegisteredAmount: action.payload.totalRegisteredAmount || 0,
                    totalApprovedRights: action.payload.totalApprovedRights || 0
                }
            };
        case TS_EVENT:
            const result = action.payload;
            const event_data = action.data;
            return { ...state, eventResult: result, eventData: event_data }

        default:
            return state;
    }
}